import { useAppSelector } from "..";

export function useDocumentTypesSelector() {
  return useAppSelector(({ documents }) => documents.documentTypes);
}

export function useDocumentCategoriesSelector() {
  return useAppSelector(({ documents }) => documents.documentCategories);
}

export function useSignaturesSelector() {
  return useAppSelector(({ documents }) => documents.signatures);
}

export function useFetchedDocumentSelector() {
  return useAppSelector(({ documents }) => documents.fetchedDocument);
}

export function useIsSigningSelector() {
  return useAppSelector(({ documents }) => documents.isSigning);
}

export function useSplitPagesSelector() {
  return useAppSelector(({ documents }) => documents.splitPages);
}

export function useDocumentIsSuccessfullySignedSelector() {
  return useAppSelector(({ documents }) => documents.documentIsSuccessfullySigned);
}

export function useDocumentBlobUrlSelector() {
  return useAppSelector(({ documents }) => documents.documentBlobUrl);
}
